import { render, staticRenderFns } from "./simple-button.vue?vue&type=template&id=263aacba&scoped=true&functional=true"
import script from "./simple-button.vue?vue&type=script&lang=js"
export * from "./simple-button.vue?vue&type=script&lang=js"
import style0 from "./simple-button.vue?vue&type=style&index=0&id=263aacba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "263aacba",
  null
  
)

export default component.exports